/**
 * The operator's identification, shown in the Terms, the Privacy Policy and the
 * Refund Policy (and in their master documents under docs/legal/). One copy, so
 * the three pages cannot disagree. Source: the owner, 2026-10-24 — Inverio is
 * operated by the sole proprietorship (raison individuelle) A. Kouadio INVARK
 * until a spin-off entity exists; when it does, change it here and in the
 * documents together (operator-particulars.test.ts checks both).
 */
export const OPERATOR_ADDRESS = 'Rue Gustave Moynier 8, 1202 Geneva, Switzerland';
export const OPERATOR_UID = 'CHE-138.474.789';

/** The contact-card line every legal page carries. */
export const OPERATOR_PARTICULARS = `Registered address: ${OPERATOR_ADDRESS} · UID ${OPERATOR_UID}`;
